module.exports = __webpack_public_path__ + "assets/temperaturaB.2fede32c46f41b125f47c6fc0c1121b9.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/temperaturaB.png
// module id = 876
// module chunks = 0